import * as React from 'react'
import { ModuleLayout } from '../../components/ModuleLayout'
import { BlipChat } from 'blip-chat-widget'
import './index.scss'

export const ChatModule: React.FC = () => {
  const appKey = 'cHJkc2l0ZWVhcHByb3V0ZXI6OWNiZTQ0YjEtMzVkZi00ODNjLThmZjktY2RiZmU5ZmEzOTc3'

  const blipClient = new BlipChat()

  const customStyle = `
    #blip-chat-header {
      display: none;
    }

    #app {
      padding-top: 0px;
      height: 100%;
    }
  `

  blipClient
    .withAppKey(appKey)
    .withCustomCommonUrl('https://petz.chat.blip.ai/')
    .withCustomStyle(customStyle)
    .withAccount({
      extras: {
        userOrigin: 'sitePetz',
      },
    })

  React.useEffect(() => {
    blipClient.withTarget('chatContainerModule').build()
  }, [])

  return (
    <ModuleLayout>
      <div id="chatContainerModule"></div>
    </ModuleLayout>
  )
}
